<template>
  <v-app>
    <Alert />
    <router-view></router-view>
    <v-footer app bottom fixed padless color="white">
      <v-col class="text-center text-caption" cols="12">
        D.R. © Solena Ag, Inc.
        <strong> {{ new Date().getFullYear() }}</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
};
</script>

<style scoped>
/* .main__wrap {
  background-color: #1c4220 !important;
} */
</style>
